<template>
  <div class="signup-step">
    <h2>
      {{ t('step4_title_prefix') }}
      <span class="grad">{{ t('step4_title_grad') }}</span>
      {{ t('step4_title_suffix') }}
    </h2>
    <p class="sub">{{ t('step4_sub') }}</p>

    <div class="intent-grid">
      <button
        v-for="intent in intents"
        :key="intent.value"
        type="button"
        class="intent-card"
        :class="{
          selected: preferences.includes(intent.value),
          'intent-card--full': intent.fullWidth,
        }"
        @click="toggleIntent(intent.value)"
      >
        <span class="ic-custom"><component :is="intent.icon" :size="22" /></span>
        <span class="lbl">{{ t(intent.labelKey) }}</span>
        <span class="desc">{{ t(intent.descKey) }}</span>
        <span class="check-mark"><icon-check :size="11" /></span>
      </button>
    </div>
  </div>
</template>

<script>
import { i18nMixin } from '../helpers';
import { INTENTS } from '../signupConfig';
import IconCheck from '../../icons/IconCheck.vue';

export default {
  name: 'IntentStep',
  mixins: [i18nMixin],
  components: {
    IconCheck,
  },
  props: {
    preferences: { type: Array, default: () => [] },
  },
  data() {
    return {
      intents: INTENTS,
    };
  },
  methods: {
    // Same rules as PreferencesChooseMixin: picking "no_answer" clears the rest;
    // picking anything else clears "no_answer".
    toggleIntent(value) {
      if (this.preferences.includes(value)) {
        this.$emit(
          'update:preferences',
          this.preferences.filter((v) => v !== value),
        );
        return;
      }
      const next =
        value === 'no_answer'
          ? ['no_answer']
          : [...this.preferences.filter((v) => v !== 'no_answer'), value];
      this.$emit('update:preferences', next);
    },
  },
};
</script>
